export enum ParserStateEnum {
    Init = 0,
    Run = 1,
    Completed = 2,
    Skip = 3,
}

export interface ParserStateInfo {
    state: ParserStateEnum;
    appId: number;
    skinCompletedCount?: number | null;
    start?: string | null; // ISO string
    end?: string | null;   // ISO string
    errorCount?: number | null;
    total?: number | null;
}

export interface ParserHistoryInfo {
    gameId: number;
    start: string; // ISO string
    end: string;   // ISO string
    skinCount: number;
    errorCount: number;
}

export interface ParserInfo {
    state: ReadonlyArray<ParserStateInfo>;
    history: ReadonlyArray<ParserHistoryInfo>;
}


